import { useAuth } from "@/auth/AuthProvider";
import { useStore } from "@/store/StoreContext";

export type PermModule = "calendar" | "customers" | "messages" | "campaigns" | "treatments" | "products" | "pricing" | "packages" | "expenses" | "stats" | "shifts" | "attendance" | "settings" | "users";
export type PermAction = "view" | "edit" | "delete";
export type PermMatrix = Record<string, Record<string, boolean>>;

/** `can(module, action)` for the selected store's brand — the effective matrix /auth/me computed from role
 * defaults and per-assignment overrides; the owner can do anything. Buttons the caller may not use are rendered
 * disabled with a tooltip, never hidden-but-clickable. */
export function usePerm() {
  const { me } = useAuth();
  const { store } = useStore();
  const brandId = store?.brand_id;
  const owner = !!me?.roles.some((r) => r.role === "owner");
  const can = (module: PermModule, action: PermAction = "view", brand?: string | null) => {
    if (owner) return true;
    const b = brand ?? brandId;
    const perBrand = b ? me?.permissions?.[b] : undefined;
    const star = me?.permissions?.["*"];
    return !!(perBrand?.[module]?.[action] || star?.[module]?.[action]);
  };
  return { can, owner };
}
